import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import FuseTheme from '../global/theme';
import Button from 'material-ui/FlatButton';
import ContentView from 'material-ui/svg-icons/image/remove-red-eye';
import ContentCreate from 'material-ui/svg-icons/content/create';

const styles = {
    column: {display: 'block', padding: '2px 12px 0 12px', lineHeight: 1},
    button: {padding: '0 4px'},
    icon: {color: FuseTheme.palette.primary1Color, overflow: 'inherit', verticalAlign: 'middle', marginLeft: 6},
};

const LinkedTextField = ({record = {}, source, linkPath, linkType, hideText, elStyle}) => {
    let editOrShow = (linkType === 'show') ? '/show' : '';
    return (
        <span style={{...elStyle, ...styles.column}}>
            <Button
                containerElement={<Link to={`${linkPath}/${record[source]}${editOrShow}`}/>}
                style={styles.button}
            >
                {!hideText &&
                <span>{record[source]}</span>
                }

                {linkType === 'edit' &&
                <ContentCreate style={styles.icon}/>
                }
                {linkType === 'show' &&
                <ContentView style={styles.icon}/>
                }
            </Button>
        </span>
    )
};

LinkedTextField.propTypes = {
    addLabel: PropTypes.bool,
    basePath: PropTypes.string,
    elStyle: PropTypes.object,
    hideText: PropTypes.bool,
    label: PropTypes.string,
    linkPath: PropTypes.string,
    linkType: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string,
};

LinkedTextField.defaultProps = {
    addLabel: true,
    hideText: false,
    linkType: 'edit',
    style: {padding: 0},
};

export default LinkedTextField;


// WEBPACK FOOTER //
// ./src/Fuse/components/LinkedTextField.js